export default __webpack_public_path__ + "static/logotipo_1_png-82e77fc4f129ce96a58cf7ca8463e4a9.png";